import { QuestionnaireAttemptOverallResultEnum, SubmitEvaluationInput, SubmitEvaluationResponse } from '@/models/gen/graphql';

import { SubmitEvaluationDocument } from '@/api/queries';
import graphApi from '@/api';

const [_, runSubmitEvaluation] = graphApi(SubmitEvaluationDocument);

export const submitEvaluation = async (
  evaluationId: string,
  overallResult: QuestionnaireAttemptOverallResultEnum,
  notes?: string
): Promise<SubmitEvaluationResponse> => {
  if (!evaluationId) throw new Error('submitEvaluation: no evaluation id provided');
  if (!overallResult) throw new Error('submitEvaluation: no overall result provided');

  const input: SubmitEvaluationInput = { evaluationId, overallResult, notes };
  const res = await runSubmitEvaluation({ input });

  return res?.submitEvaluation;
};
